export default class BranchConstants {

    public static GraphColors = [{
        backgroundColor: [
            '#c80101', '#013796', '#ff6414', '#009102', '#3d004d', '#ffff00', '#1b6efe', '#00e604', '#b33c00', '#fe4d4d', '#702602', '#96be25', '#be2596', '#9925be', '#041014', '#1a6985', '#92cbdf', '#134c0f', '#5d6522', '#652237', '#c1a7af', '#e1a8ba', '#5a434a', '#73b8db', '#db8573', '#995d51', '#b173db']
    }];
    public static chartOneTitle = 'SUMMARY';
    public static chartTypes1 = ['PIE', 'HORIZONTALBAR', 'COMPARISION'];
    public static chartTypes2 = ['STACKED', 'LINE'];
    public static lowHour = ['00', '01', '02', '03', '04', '05', '10', '11', '12', '13', '14', '15', '20', '21', '22', '23'];
    public static peakMorningHour = ['06', '07', '08'];
    public static peakEvnHour = ['16', '17', '18'];
    public static letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    public static daysList = ['1', '2', '3', '4', '5', '6', '0'];
    public static summaryStackedChartLables = ['All' + '\n' + '(0 - 23)', 'Low', 'Peak(Morning)' + '\n' + '(6 - 9)', 'Peak(Evening)' + '\n' + '(16 - 19)'];
    public static days = ['MO', 'TU', 'WE', 'THU', 'FR', 'SAT', 'SUN'];
    public static periods =  ['ALL(0-24)', 'PEAK MORNING(6-9)', 'PEAK EVENING(16-19)', 'LOW'];
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/constants/branch-constant.ts